import React from 'react'
import { Breadcrumb, BreadcrumbItem } from 'reactstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const BreadcrumbCommon = ({ children, customPath, customLinkText }) => {
  const { t } = useTranslation()

  const path = customPath || '/'
  const linkText = customLinkText || t('common.page.admin.dashboard')

  return (
    <Breadcrumb>
      <BreadcrumbItem>
        <Link to={path}>
          {customPath && <FontAwesomeIcon className='nav-icon mr-1' icon={faArrowLeft}/>}
          {linkText}
        </Link>
      </BreadcrumbItem>
      {children}
    </Breadcrumb>
  )
}

export default BreadcrumbCommon
